import React from 'react'
import { Link } from 'react-router-dom'
import { corporateSiteUrl } from '@environments/environment'

import './RightSidebar.css'

type Props = {
    //
}

const RightSidebar: React.FC<Props> = () => (
  <>
    <Link to={{ pathname: '/vote2022' }}>
      <img src="/assets/img/gmts_pc_banner-01.png" alt="" />
    </Link>
    <Link to={{ pathname: `${corporateSiteUrl}/` }} target="_blank">
      <img src="/assets/img/gmts_pc_banner-02.png" alt="" />
    </Link>
    <Link to={{ pathname: `${corporateSiteUrl}/price/` }} target="_blank">
      <img src="/assets/img/gmts_pc_banner-03.png" alt="" />
    </Link>
    <Link to={{ pathname: `${corporateSiteUrl}/how-to-start/` }} target="_blank">
      <img src="/assets/img/gmts_pc_banner-04.png" alt="" />
    </Link>
    <Link to={{ pathname: `${corporateSiteUrl}/faq/` }} target="_blank">
      <img src="/assets/img/gmts_pc_banner-05.png" alt="" />
    </Link>
  </>
)

export default RightSidebar
